import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { priceShow } from 'shared/lib/priceShow.ts'
import { MbonusLineBeket } from 'shared/ui/beket/mbonus-line-beket'
import { Button } from 'shared/ui/button'

import s from './styles.module.scss'

interface Props {
  price: string
  count: number
  bonus?: string
  isDisabled?: boolean
  onClick?: () => void
}

export const FormFooter = ({
  price,
  count,
  bonus,
  isDisabled = false,
  onClick,
}: Props) => {
  const { t } = useTranslation()

  return (
    <div className={s.wrapper}>
      <div className={s.container}>
        <div className={s.infoWrapper}>
          <div className={s.info}>
            <p className={clsx(s.text, 'regular-16')}>
              {t('purchase_page.price_for_passengers', { count })}
            </p>
            <p className={clsx(s.price, 'bold-17')}>
              {priceShow(price)} &#8384;
            </p>
          </div>

          {bonus && <MbonusLineBeket bonus={bonus} />}
        </div>

        <Button
          disabled={isDisabled}
          className={clsx(s.button, 'semi-bold-16')}
          onClick={onClick}
        >
          {t('continue')}
        </Button>
      </div>
    </div>
  )
}
